
import Vue from 'vue'
import staticBlockMixin from '~/mixins/staticBlockMixin'

export default Vue.extend({
  name: 'InfoSquare',
  mixins: [staticBlockMixin],
  props: {
    isContentReverse: {
      type: Boolean,
      required: false,
      default: false
    },
    bodyLink: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    isLocalUrl () {
      return !this.mainFields?.link?.value?.startsWith('https://') && !this.mainFields?.link?.value?.startsWith('mailto:')
    }
  },
  methods: {
    goToLinkByBodyClick () {
      if (!this.mainFields?.link?.value) { return }

      if (this.isLocalUrl) {
        this.$router.push(this.mainFields?.link?.value)
      } else {
        window.open(this.mainFields?.link?.value, '_blank')
      }
    }
  }
})
